// Helpers de apresentação dos dados da loja (CompanyResponseDTO de GET /companies/{code}).
// Os campos podem vir nulos/omitidos: sempre caem em um fallback.

// Contato padrão (Bonfim Gourmet) usado enquanto a empresa carrega ou se não tiver telefone
export const DEFAULT_WHATSAPP = "5511991882938";

const onlyDigits = (value) => String(value || "").replace(/\D/g, "");

/**
 * Número no formato do wa.me (DDI 55 + DDD + número).
 * Aceita "(11) 9 9188-2938", "11991882938" ou "+55 11 99188-2938".
 */
export const getWhatsAppNumber = (company, fallback = DEFAULT_WHATSAPP) => {
  const digits = onlyDigits(company?.contactPhone);
  if (digits.length === 10 || digits.length === 11) return `55${digits}`;
  if (digits.length >= 12 && digits.startsWith("55")) return digits;
  return fallback;
};

/** Telefone legível: (11) 9 9188-2938 / (11) 3333-4444 */
export const formatPhoneDisplay = (value) => {
  let d = onlyDigits(value);
  if (d.length >= 12 && d.startsWith("55")) d = d.slice(2);
  if (d.length === 11) return `(${d.slice(0, 2)}) ${d[2]} ${d.slice(3, 7)}-${d.slice(7)}`;
  if (d.length === 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return value || "";
};

/** Monta o link wa.me com mensagem opcional */
export const buildWhatsAppUrl = (number, message = "") =>
  `https://wa.me/${number}${message ? `?text=${encodeURIComponent(message)}` : ""}`;

/**
 * A loja está aberta? `available` vem do painel (abrir/fechar a loja).
 * Enquanto não carregou (company null) devolve null para não exibir status errado.
 */
export const isCompanyOpen = (company) => {
  if (!company) return null;
  return company.available !== false;
};
